var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamCollaboration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x30_6_Collaborate"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 103.042,
    cy: 301.93,
    fill: "#ffcbc0",
    r: 40.002
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.3 429.479h-142.538c-9.137 0-16.388-8.252-14.619-17.213 8.017-40.144 43.445-70.326 85.888-70.326s77.871 30.182 85.888 70.326c1.768 8.961-5.423 17.213-14.619 17.213z",
    fill: "#3eb655"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.979,
    cy: 301.93,
    fill: "#ffcbc0",
    r: 40.002
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.237 429.479h-142.538c-9.137 0-16.388-8.252-14.619-17.213 8.017-40.144 43.445-70.326 85.888-70.326s77.871 30.182 85.888 70.326c1.769 8.961-5.423 17.213-14.619 17.213z",
    fill: "#df7f19"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.007,
    cy: 43.659,
    fill: "#ffcbc0",
    r: 40.002
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.265 171.209h-142.538c-9.137 0-16.388-8.252-14.619-17.213 8.017-40.144 43.445-70.326 85.888-70.326s77.871 30.182 85.888 70.326c1.769 8.961-5.423 17.213-14.619 17.213z",
    fill: "#d81a60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.939 412.293c-1.806 8.925 5.472 17.212 14.609 17.212h-15.778c-9.137 0-16.415-8.287-14.609-17.212 8.022-40.162 43.403-70.337 85.85-70.337 2.656 0 5.259.106 7.862.372-38.887 3.454-70.443 32.353-77.934 69.965z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.831 412.293c-1.753 8.925 5.525 17.212 14.662 17.212h-15.778c-9.137 0-16.416-8.287-14.662-17.212 8.022-40.162 43.456-70.337 85.903-70.337 2.656 0 5.26.106 7.863.372-38.888 3.454-70.497 32.353-77.988 69.965z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.885 154.001c-1.753 8.978 5.472 17.212 14.609 17.212h-15.778c-9.138 0-16.363-8.235-14.609-17.212 8.022-40.163 43.456-70.337 85.903-70.337 2.656 0 5.259.106 7.862.372-38.887 3.453-70.496 32.352-77.987 69.965z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m483.404 276.173c-2.884 0-5.255-2.309-5.312-5.206-1.805-90.74-60.237-172.718-145.393-203.993-2.755-1.009-4.166-4.062-3.154-6.817 1.012-2.752 4.078-4.163 6.817-3.154 90.628 33.283 150.43 117.186 152.355 213.752.057 2.934-2.272 5.359-5.209 5.419-.037-.001-.073-.001-.104-.001z",
    fill: "#36474f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m28.596 276.173c-.036 0-.067 0-.104 0-2.936-.06-5.266-2.485-5.209-5.419 1.925-96.565 61.727-180.468 152.355-213.751 2.744-1.012 5.805.402 6.817 3.154 1.012 2.755-.399 5.808-3.154 6.817-85.155 31.276-143.587 113.253-145.392 203.993-.058 2.898-2.428 5.206-5.313 5.206z",
    fill: "#36474f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 508.342c-42.609 0-84.315-11.634-120.61-33.647-2.511-1.52-3.31-4.788-1.79-7.297 1.525-2.511 4.794-3.305 7.299-1.787 34.635 21.003 74.437 32.106 115.1 32.106s80.465-11.102 115.1-32.106c2.511-1.515 5.779-.719 7.299 1.787 1.52 2.508.721 5.777-1.79 7.297-36.293 22.014-77.999 33.647-120.608 33.647z",
    fill: "#36474f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamCollaboration);
export default __webpack_public_path__ + "static/media/team-collaboration.dfcc6977ea5aef894a6515195783d104.svg";
export { ForwardRef as ReactComponent };